export default "__VITE_ASSET__BSGe6ICi__"